import { render } from "./Loading.vue?vue&type=template&id=5e3812cc&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=5e3812cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3812cc"]])

export default __exports__